// ============================================================================
// objectIcons.ts — ЕДИНЫЙ источник иконок типов объектов и папок почты задач
// (SSoT). Используется плитками разделов (ObjectCard variant=tile) и везде,
// где нужно показать тип объекта иконкой. Никаких разрозненных карт иконок.
// ============================================================================

import {
  BookOpen, FileText, Database, ListChecks, Users, Shield,
  Palette, FolderOpen, Layers, Inbox, LogOut, ClipboardList,
} from 'lucide-react';

export type ObjectIcon = React.ComponentType<{ className?: string }>;

// Иконка типа объекта (catalog/document/register/task/entity/role/theme/...)
export function objectTypeIcon(objectType: string): ObjectIcon {
  switch (objectType) {
    case 'catalog': return BookOpen;
    case 'document': return FileText;
    case 'register': return Database;
    case 'task':
    case 'tasks': return ListChecks;
    case 'order':
    case 'orders': return ClipboardList;
    case 'entity': return Users;
    case 'role': return Shield;
    case 'theme': return Palette;
    default: return FolderOpen;
  }
}

// Иконка папки почты задач (kind: all/inbox/pool/outbox/status/...)
export function folderKindIcon(kind: string): ObjectIcon {
  switch (kind) {
    case 'all': return Layers;
    case 'inbox': return Inbox;
    case 'pool': return FolderOpen;
    case 'outbox': return LogOut;
    default: return FolderOpen;
  }
}
